import type { PropsWithChildren, ReactElement } from 'react'
import FluentSpinnerIos16Filled from '~icons/fluent/spinner-ios-16-filled'
import { cx } from 'src/utils/cx'

export interface UISpinnerLoadingProps extends PropsWithChildren {
  loading?: boolean
  className?: string
}

export const UISpinnerLoading = (
  props: UISpinnerLoadingProps,
): ReactElement => {
  if (props.loading) {
    return (
      <FluentSpinnerIos16Filled
        className={cx('animate-spin', props.className)}
      />
    )
  }

  return props.children as ReactElement
}
